




























import { Vue, Component } from 'vue-property-decorator';
import VoteList from './components/VoteList.vue';
import * as config from './config';
@Component({
  components: {
    VoteList,
  },
})
export default class First extends Vue {
  opthines = config.OPTHINES;

  // 去详情
  enterDetailPage(id: any) {
    this.$router.push({
      path: './Detail',
      query: { id },
    });
  }
}
